module.exports = __webpack_public_path__ + "img/a1857e9.png";